/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
const getWikiProducts = (data) => {
    let finalResult = [];
    const products = data.map((item) => {
        const modifiedItem = {
            id: item.id,
            product_name: item.name,
            product_picture: `${item.image.path}${item.image.name}x.jpg`,
            slug: item?.seo?.url,
            type: 'product',
        };
        return modifiedItem;
    });
    const alphabets = [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
    ];
    if (products && products.length) {
        let regex = '';
        let matchingProducts = [];
        alphabets.forEach((alphabet) => {
            matchingProducts = [];
            const obj = {
                type: 'alphabet',
                alphabet,
                status: 0,
            };
            regex = new RegExp(`^${alphabet}`);
            matchingProducts = products.filter((item) => item.product_name.toUpperCase().match(regex));
            obj.status = matchingProducts && matchingProducts.length > 0 ? 1 : 0;
            finalResult.push(obj);
            if (matchingProducts && matchingProducts.length > 0) {
                finalResult.push(matchingProducts);
            }
        });
        finalResult = [].concat(...finalResult);
    } else {
        alphabets.forEach((alphabet) => {
            const obj = {
                type: 'alphabet',
                alphabet,
                status: 0,
            };
            finalResult.push(obj);
        });
        finalResult = [].concat(...finalResult);
    }
    return finalResult;
};

export default getWikiProducts;
